import {subMonths} from "date-fns";
import { type ContactSearchData, type ValueContactFilter, type RangeContactFilter, ContactFilterType } from "../../types/api.types";

const createSearchParams = (filters: (ValueContactFilter | RangeContactFilter)[]): ContactSearchData => ({
  type: 'search-params',
  attributes: {
    filters,
    page: {
      size: 1,
      current: 1,
    },
  },
});

const createValueFilter = (name: string, value: string[]): ValueContactFilter => ({
  type: ContactFilterType.Value,
  name,
  value,
});

const createRangeFilter = (name: string, min: string, max: string, exclusiveMax?: string | number): RangeContactFilter => ({
  type: ContactFilterType.Range,
  name,
  min,
  max,
  exclusiveMax: exclusiveMax ?? max,
});

export const QuickActionsPayload: ContactSearchData[] = [
  createSearchParams([
    createValueFilter('totalCompletedOrdersRange', ['at_least_two']),
  ]),

  createSearchParams([
    createValueFilter('hasProductsInCart', ['has_cart_activity_in_last_30_days']),
  ]),

  createSearchParams([
    createRangeFilter(
      'ordering.lastOrderedAt',
      subMonths(new Date(), 6).toISOString(),
      subMonths(new Date(), 3).toISOString()
    ),
  ]),

  createSearchParams([
    createValueFilter('freeShippingInterval', ['eligible']),
  ]),

  createSearchParams([
    createValueFilter('retailer.aksPlus.active', ['1']),
  ]),

  createSearchParams([
    createValueFilter('retailer.contact.country', ['FR']),
  ]),
];
